import React from 'react';
import TotalUserStats from './TotalUserStats';
import ScenarioUsage from './ScenarioUsage';
import TokenUsage from './TokenUsage';
import CustomizedRolePlays from './CustomizedRolePlays';
import TokenUsageByCompany from './TokenUsageByCompany';
import CompetencyTrends from './CompetencyTrends';
import FeedbackOverview from './FeedbackOverview';
import DashboardHeader from './DashBoardHeader';
import HeyGenUses from './HeyGenUses';
import { DashboardFilterProvider } from './context/DashboardContext.js';

const DashBoard = () => {
    return (
        <DashboardFilterProvider>
            <div className="p-6 space-y-6" style={{
                display: "flex", flexDirection: "column", gap: "24px"
            }}>
                <DashboardHeader />
                <TotalUserStats />
                <ScenarioUsage />
                <CustomizedRolePlays />

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
                    <div style={{ gridColumn: 'span 1' }}>
                        <TokenUsage />
                    </div>
                    <div style={{ gridColumn: 'span 2' }}>
                        <TokenUsageByCompany />
                    </div>
                </div>

                <HeyGenUses />
                <CompetencyTrends />
                <FeedbackOverview />
            </div>
        </DashboardFilterProvider>
    )
}
export default DashBoard;